export default {
  all: [],
  one: {},
  progress: null,
};
